"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { AuthModule } from '@shared/auth';
import { ErrorTracking, PerformanceTracking } from '@shared/tracking';
import { ApiHttp } from './api-http.service';
import { Datastore } from './datastore';
import { DATASTORE_CONFIG } from './datastore.config';
import { errorHandlerReducerFactory } from './error-handler.reducer';
import { MessagesEffect } from './message/messages.effect';
import { RequestDataEffect } from './request-data.effect';
import { sessionStorageSyncFactory } from './session-storage-sync.reducer';
import { reducers } from './store';
import { storeFreezeReducerFactory } from './store-freeze.reducer';
import { WebSocketService } from './websocket';
// FIXME: use MetaReducer[] as the return type once
// https://github.com/ngrx/platform/pull/270 has been released
export function getMetaReducers(errorTracking, performanceTracking, config) {
    var metaReducers = [
        errorHandlerReducerFactory(errorTracking),
        sessionStorageSyncFactory(performanceTracking),
    ];
    if (config.enableStoreFreeze) {
        metaReducers.push(storeFreezeReducerFactory(performanceTracking));
    }
    return metaReducers;
}
var DatastoreModule = (function () {
    function DatastoreModule() {
    }
    DatastoreModule_1 = DatastoreModule;
    DatastoreModule.initialize = function (config) {
        return {
            ngModule: DatastoreModule_1,
            providers: [
                Datastore,
                { provide: DATASTORE_CONFIG, useValue: config },
                {
                    provide: META_REDUCERS,
                    deps: [ErrorTracking, PerformanceTracking, DATASTORE_CONFIG],
                    useFactory: getMetaReducers,
                },
            ],
        };
    };
    DatastoreModule = DatastoreModule_1 = __decorate([
        NgModule({
            imports: [
                HttpClientModule,
                AuthModule,
                StoreModule.forRoot(reducers),
                EffectsModule.forRoot([]),
                EffectsModule.forFeature([MessagesEffect, RequestDataEffect]),
            ],
            providers: [ApiHttp, WebSocketService],
        })
    ], DatastoreModule);
    return DatastoreModule;
    var DatastoreModule_1;
}());
export { DatastoreModule };



// WEBPACK FOOTER //
// datastore.module.js